import { ICustomEvent } from '../models/ICustomEvent';
import { IEvent } from '../models/IEvent';

export function adaptEventToCustomEvent({
	category, // Event category - e.g.: Vehicle Management
	action, // Event action - e.g.: add_vehicle. This will show up as the event name in GA4.

	label, //	e.g. The title of a redeem offer, or a date label.
	value, // e.g. The price of a parking option
	id, // e.g. the id of the clicked item

	screenName, // the screen from which the event was fired
}: IEvent): ICustomEvent {
	// These are the params sent to GA4
	return {
		name: action,
		category,
		screen_name: screenName,
		value,
		label,
		id,
	};
}
